module.exports = __webpack_public_path__ + "assets/media/shop.7798ccd1.ogg";